import { usePage } from "#shared/helpers/usePage";

export const useDataChunkSize = (PAGE_SIZE: number) => {
  const { currentPage } = usePage();

  const limit = parseInt(currentPage) * PAGE_SIZE;

  return { dataChunkSize: limit };
};
